import * as React from 'react';
import { SVGProps } from 'react';

const IconOpenInNewSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M11 3.994V2h11.02v11h-1.993l-.007-7.585-8.606 8.606L10 12.607 18.605 4 11 3.994z" />
    <path d="M4 6h5V4H2v18h18v-7h-2v5H4V6z" />
  </svg>
);
export default IconOpenInNewSizeM;
